import { PathSegmentResolver } from '../../utils/use-path';

export const resolveNameSearchPath: PathSegmentResolver = ({ defaultLink }) => {
  return {
    title: 'Sök med namn / artikelnummer / EAN',
    isPageTitle: true,
    link: defaultLink + location.search, // add search params to keep search value
  };
};
